import React, { useContext } from 'react';
import {
    makeStyles,
    Divider,
    Typography
} from '@material-ui/core';
import { api, Dialog, IconEstrella, Link, PortalContext } from '@portal/arq-portal-core';

import {
    DetalleProducto,
    ProductoProps
} from './DetalleProducto';
import { useSWRConfig } from 'swr';

const useStyles = makeStyles({
    producto: {
        display: 'inline-block',
        width: '100%'
    },
    productoFila: {
        margin: '10px 0',
        display: 'flex',
        justifyContent:'space-between'
    },
    productoEnlaceContainer: {
        color: '#dc0028'
    },
    productoEnlace: {
        fontWeight: 'bold'
    },
    iconWrapper: {
        // position: 'absolute',
        // right: 0,
        // zIndex: 100,
        cursor: 'pointer',
        '& svg': {
          fontSize: '14px',
          paddingRight: '.5rem',
          '&:hover': {
            color: '#919191',
          },
          '&:active': {
            color: '#dc0028',
          },
        },
      },
});


export const Producto = ({producto, favs}: ProductoProps) => {
    const [mostrarModal, setMostrarModal] = React.useState(false);
    const {user} = useContext(PortalContext);
    const { mutate } = useSWRConfig();
    const esFav = producto.id && favs && favs?.find((x: any) => x.Url != null && x.Url.toLowerCase() == producto.id.toLowerCase()) != null;
    const esAccesoRapido = producto.id && favs && favs?.find((x: any) => x.Url != null && x.Url.toLowerCase() == producto.id.toLowerCase() && (x.AccesoRapido != null)) != null;
    const clases = useStyles();

    const AddFavorito = (menuId: string, titulo?: string) => {
        mutate(["favoritos", user?.id], () => api.post( "/be/favsadd", {
          Entrada: {
            Titulo: titulo,
            Url: menuId,
            Tipo: "Menu"
          }
        }), false);
      };
    
      const DelFavorito = (menuId: string, esAccesoRapido: Boolean) => {
        if (esAccesoRapido) {
          setMostrarModal(true);
        } else {
          manejarAceptar(menuId);
        }
      };
    
      const manejarCierre = () => {
        setMostrarModal(false);
      };
    
      const manejarAceptar = (url: string) => {
        mutate(["favoritos", user?.id], () => api.post("/be/favsdel", {
          Entrada: {
            Url: url,
            Tipo: "Menu"
          }
        }), false);
        setMostrarModal(false);
      };




    return (
        <div className={clases.producto}>
            <div className={clases.productoFila}>
                <Link to={producto.url} className={clases.productoEnlaceContainer}>
                    <Typography variant='caption' className={clases.productoEnlace}>{producto.titulo} 
                    </Typography>
                </Link>
                {producto && !producto.enlaces && <span className={clases.iconWrapper}>
                        <IconEstrella style={{ color: esFav ? "#dc0028" : "#606060" }}
                            onClick={(e: any) => {
                            !esFav ? AddFavorito(producto.id, producto.titulo) :  DelFavorito(producto.id,esAccesoRapido);
                            e.stopPropagation()
                            }} />
                        </span> }
            </div>
            {producto.enlaces &&
                <React.Fragment>
                    <Divider />
                    {producto.enlaces.map((enlace: any) => {return enlace? <DetalleProducto producto={enlace} /> : null }
                    )}
                </React.Fragment>
            }
            {
            mostrarModal &&
            <Dialog
              title="Eliminar favorito"
              open={mostrarModal}
              manejarCierre={manejarCierre}
              guardar={() => manejarAceptar(producto.id)}
              tituloAceptar="Eliminar"
            >
              <p>Este Favorito está marcado como Acceso Rápido, al eliminarlo también se eliminará el Acceso Rápido. ¿Estás seguro de que quieres eliminarlo?</p>
            </Dialog>
          }
        </div>
    );
};